import { render, staticRenderFns } from "./IconRssOutline.vue?vue&type=template&id=089675b6"
import script from "./IconRssOutline.vue?vue&type=script&lang=js"
export * from "./IconRssOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports